// errors.ts
function pathToString(path) {
  return path.reduce((string, key, index) => {
    if (typeof key === "number") return `${string}[${key}]`;
    return index === 0 ? key : `${string}.${key}`;
  }, "");
}
var ValidationError = class _ValidationError extends Error {
  /** An `Array` of validation errors encountered while validating */
  errors;
  /** Our stack, always present as we enforce it in the constructor */
  stack;
  constructor(builderOrCause, constructorOrPath, maybeConstructor) {
    let constructor;
    let errors;
    if (builderOrCause instanceof ValidationErrorBuilder) {
      errors = builderOrCause.errors;
      constructor = builderOrCause.assert;
    } else {
      const path = Array.isArray(constructorOrPath) ? constructorOrPath : [];
      if (builderOrCause instanceof _ValidationError) {
        errors = builderOrCause.errors.map(({ path: subpath, message: message2 }) => ({ path: [...path, ...subpath], message: message2 }));
      } else {
        errors = [{ path, message: `${builderOrCause}` }];
      }
      constructor = typeof maybeConstructor === "function" ? maybeConstructor : typeof constructorOrPath === "function" ? constructorOrPath : _ValidationError;
    }
    const details = errors.map(({ path, message: message2 }) => ({ key: pathToString(path), message: message2 })).map(({ key, message: message2 }) => key ? `${key}: ${message2}` : message2).join("\n  ");
    const message = errors.length !== 1 ? `Found ${errors.length} validation errors` : "Found 1 validation error";
    super(`${message}
  ${details}`);
    Error.captureStackTrace?.(this, constructor);
    Object.defineProperty(this, "errors", { value: errors });
  }
};
ValidationError.prototype.name = "ValidationError";
var ValidationErrorBuilder = class {
  /** The current list of validation errors */
  errors = [];
  /**
   * Record a validation error associated with the specified key.
   *
   * @param error - The error (normally a `string` or a `ValidationError`)
   *                to record and associate with the given key
   * @param key - The key in an object, or index in an array where the
   *              vaildation error was encountered
   */
  record(error, ...key) {
    const path = [...key];
    if (error instanceof ValidationError) {
      error.errors.forEach(({ path: subpath, message }) => {
        this.errors.push({ path: [...path, ...subpath], message });
      });
    } else {
      this.errors.push({ path, message: `${error}` });
    }
    return this;
  }
  /**
   * Assert there are no validation errors and return the specified value, or
   * throw a `ValidationError` combining all errors
   *
   * @param value - The value to return if no errors have been recorded
   */
  assert(value) {
    if (this.errors.length > 0) throw new ValidationError(this);
    return value;
  }
};
function assertValidation(what, message) {
  if (!what) throw new ValidationError(message, assertValidation);
}
function assertSchema(what, message) {
  if (!what) throw new TypeError(message);
}
export {
  ValidationError,
  ValidationErrorBuilder,
  assertSchema,
  assertValidation
};
//# sourceMappingURL=errors.mjs.map
